import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Smartphone, CreditCard, ShieldCheck, Sparkles, Calendar } from 'lucide-react';
export function OfferStack() {
  const [addReels, setAddReels] = useState(false);
  const [addCalendar, setAddCalendar] = useState(false);
  // IDs de Variantes de Shopify
  const ID_TOOLKIT = '43864513380440';
  const ID_REELS = '43864611520600';
  const ID_CALENDAR = '43864790302808';
  // Precios
  const basePrice = 17;
  const reelsPrice = 9.99;
  const calendarPrice = 27;
  let totalPrice = basePrice;
  if (addReels) totalPrice += reelsPrice;
  if (addCalendar) totalPrice += calendarPrice;
  const getCheckoutLink = () => {
    let items = [`${ID_TOOLKIT}:1`];
    if (addReels) items.push(`${ID_REELS}:1`);
    if (addCalendar) items.push(`${ID_CALENDAR}:1`);
    return `https://checkout.digitalsolvex.shop/cart/${items.join(',')}`;
  };
  return <section id="comprar" className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-5xl mx-auto overflow-hidden w-full relative z-20" data-id="element-149">
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-green-500/10 rounded-[40px] blur-[100px]" data-id="element-150" />

      <div className="relative bg-[#050505] border border-white/10 shadow-2xl rounded-[40px] p-6 md:p-14 overflow-hidden" data-id="element-151">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-152" />

        <div className="text-center mb-12" data-id="element-153">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-154">
            Personaliza tu <span className="text-cyan-400" data-id="element-155">Toolkit Pro</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-156">
            Añade estas herramientas exclusivas y acelera tus resultados.
          </p>
        </div>

        <div className="space-y-6 mb-12" data-id="element-157">
          {/* PRODUCTO ADICIONAL 1: REELS */}
          <div onClick={() => setAddReels(!addReels)} className={`cursor-pointer group relative transition-all duration-500 rounded-3xl border-2 overflow-hidden ${addReels ? 'border-green-500 bg-green-500/5' : 'border-white/5 bg-white/[0.02] hover:border-white/20'}`} data-id="element-158">
            <div className="flex flex-col md:flex-row items-center gap-6 p-6" data-id="element-159">
              <div className="w-full md:w-40 h-40 rounded-2xl overflow-hidden flex-shrink-0 shadow-lg border border-white/10" data-id="element-160">
                <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_qn6c7yqn6c7yqn6c.jpg?v=1773379398" className="w-full h-full object-cover" alt="50 Reels" data-id="element-161" />
              </div>
              <div className="flex-1 text-left" data-id="element-162">
                <div className="flex items-center gap-2 text-green-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-163">
                  <Sparkles className="w-4 h-4" data-id="element-164" /> Oferta Limitada
                </div>
                <h3 className="text-2xl font-black text-white mb-2" data-id="element-165">
                  Kit de 50 Reels Virales
                </h3>
                <p className="text-gray-400 text-sm md:text-base mb-4" data-id="element-166">
                  Domina el algoritmo con 50 guiones de 15 seg. Sabrás
                  exactamente qué grabar y qué decir para vender con video.
                </p>
                <div className="flex items-center gap-4" data-id="element-167">
                  <div className={`px-4 py-2 rounded-lg font-bold text-sm transition-all ${addReels ? 'bg-green-500 text-white' : 'bg-white/10 text-white'}`} data-id="element-168">
                    {addReels ? '✓ Añadido' : '＋ Añadir por $9.99'}
                  </div>
                  <span className="text-gray-600 line-through font-bold" data-id="element-169">
                    $19.99
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* PRODUCTO ADICIONAL 2: CALENDARIO */}
          <div onClick={() => setAddCalendar(!addCalendar)} className={`cursor-pointer group relative transition-all duration-500 rounded-3xl border-2 overflow-hidden ${addCalendar ? 'border-cyan-500 bg-cyan-500/5' : 'border-white/5 bg-white/[0.02] hover:border-white/20'}`} data-id="element-170">
            <div className="flex flex-col md:flex-row items-center gap-6 p-6" data-id="element-171">
              <div className="w-full md:w-40 h-40 rounded-2xl overflow-hidden flex-shrink-0 shadow-lg border border-white/10" data-id="element-172">
                <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_n6tccyn6tccyn6tc.jpg?v=1773379544" className="w-full h-full object-cover" alt="Calendario" data-id="element-173" />
              </div>
              <div className="flex-1 text-left" data-id="element-174">
                <div className="flex items-center gap-2 text-cyan-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-175">
                  <Calendar className="w-4 h-4" data-id="element-176" /> Contenido Ilimitado
                </div>
                <h3 className="text-2xl font-black text-white mb-2" data-id="element-177">
                  Calendario Anual 365 Días
                </h3>
                <p className="text-gray-400 text-sm md:text-base mb-4" data-id="element-178">
                  El fin del bloqueo mental. Una matriz exacta con ideas diarias
                  para que tus redes nunca mueran y vendas siempre.
                </p>
                <div className="flex items-center gap-4" data-id="element-179">
                  <div className={`px-4 py-2 rounded-lg font-bold text-sm transition-all ${addCalendar ? 'bg-cyan-500 text-white' : 'bg-white/10 text-white'}`} data-id="element-180">
                    {addCalendar ? '✓ Añadido' : '＋ Añadir por $27.00'}
                  </div>
                  <span className="text-gray-600 line-through font-bold" data-id="element-181">
                    $67.00
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RESUMEN DE PAGO */}
        <div className="border-t border-white/10 pt-10 text-center" data-id="element-182">
          <p className="text-gray-500 font-bold uppercase tracking-widest text-sm mb-4" data-id="element-183">
            Total de tu Pedido:
          </p>
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-184">
            <span className="font-heading text-7xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 drop-shadow-[0_0_30px_rgba(34,197,94,0.3)] leading-none" data-id="element-185">
              ${totalPrice.toFixed(2)}
            </span>
          </div>

          <motion.a href={getCheckoutLink()} whileHover={{
          scale: 1.02,
          y: -4
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex flex-col items-center justify-center w-full max-w-2xl px-8 py-6 bg-gradient-to-r from-green-500 to-cyan-500 rounded-3xl shadow-[0_20px_50px_-10px_rgba(34,197,94,0.5)] transition-all duration-300 border border-white/20 text-decoration-none group" data-id="element-186">
            <span className="text-2xl md:text-4xl font-black text-white tracking-tight uppercase group-hover:tracking-wider transition-all" data-id="element-187">
              ¡Confirmar y Descargar!
            </span>
            <span className="mt-2 text-green-50 font-bold opacity-80 flex items-center gap-2" data-id="element-188">
              <ShieldCheck className="w-5 h-5" data-id="element-189" /> Pago Seguro en Venezuela
            </span>
          </motion.a>

          <div className="mt-10 flex flex-wrap justify-center gap-8 text-gray-500 text-xs font-bold uppercase tracking-widest" data-id="element-190">
            <span className="flex items-center gap-2" data-id="element-191">
              Pago Móvil / Binance
            </span>
            <span className="flex items-center gap-2" data-id="element-192">Entrega Inmediata</span>
            <span className="flex items-center gap-2" data-id="element-193">Garantía 7 Días</span>
          </div>
        </div>
      </div>
    </section>;
}